"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.renderListOfContacts = void 0;
require("core-js/modules/esnext.iterator.constructor.js");
require("core-js/modules/esnext.iterator.map.js");
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const renderLinkedin = (linkedinUrl, linkedinIconUrl) => {
  return /*#__PURE__*/_react.default.createElement("li", null, /*#__PURE__*/_react.default.createElement("p", null, /*#__PURE__*/_react.default.createElement("a", {
    href: linkedinUrl,
    target: "_blank",
    key: linkedinUrl
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "social-icon",
    style: {
      WebkitMaskImage: "url(".concat(linkedinIconUrl, ")"),
      maskImage: "url(".concat(linkedinIconUrl, ")")
    },
    "aria-label": linkedinUrl,
    role: "img"
  }))));
};
const renderListOfContacts = (contacts, t) => {
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, contacts.map((contact, index) => {
    return /*#__PURE__*/_react.default.createElement("div", {
      key: index
    }, /*#__PURE__*/_react.default.createElement("h3", {
      className: "con-heading con-heading__h5"
    }, contact.name), /*#__PURE__*/_react.default.createElement("div", {
      className: "con-address-container con-text con-text__large-medium"
    }, /*#__PURE__*/_react.default.createElement("ul", null, /*#__PURE__*/_react.default.createElement("li", null, /*#__PURE__*/_react.default.createElement("p", null, /*#__PURE__*/_react.default.createElement("span", null, t("Pages.Contact.Phone"), ": "), contact.phoneNum)), /*#__PURE__*/_react.default.createElement("li", null, /*#__PURE__*/_react.default.createElement("p", null, /*#__PURE__*/_react.default.createElement("span", null, t("Pages.Contact.Mobile"), ": "), contact.mobileNum)), /*#__PURE__*/_react.default.createElement("li", null, /*#__PURE__*/_react.default.createElement("p", null, /*#__PURE__*/_react.default.createElement("a", {
      className: "con-link__readmore",
      href: "mailto:" + contact.email
    }, contact.email))), contact.linkedinUrl && contact.linkedinIconUrl && renderLinkedin(contact.linkedinUrl, contact.linkedinIconUrl))));
  }));
};
exports.renderListOfContacts = renderListOfContacts;